import type { PaletteOptions } from '@mui/material';

/** Main SM dashboard (Chabad Israel centers) — single source for palette. */
export const dashboardPaletteChabadIsrael: PaletteOptions = {
  common: {
    white: '#ffffff'
  },
  warning: {
    main: '#FF891D',
    A100: '#fee7dc'
  },
  primary: {
    main: '#0E6E75',
    light: '#E6F2F3',
    contrastText: '#ffffff'
  },
  success: {
    main: '#94C11F',
    A100: '#94C11F33'
  },
  secondary: {
    main: '#F38725'
  },
  error: {
    main: '#FE5857'
  },
  info: {
    main: '#8276BE',
    dark: '#1E2A3A',
    light: '#1E2A3AE5',
    A100: '#dbd8ec',
    A200: '#e4f4fc',
    100: '#1E2A3A66',
    200: '#1E2A3A33',
    300: '#1E2A3A1A'
  },
  grey: {
    A100: '#E3E3E3',
    A200: '#f4eeef',
    50: '#757575',
    100: '#AFBDD2',
    200: '#D6DCE5',
    300: '#E5E9F1',
    400: '#E6E9F3',
    500: '#E7ECF6',
    600: '#F2F4F9',
    700: '#F2F4F9B2',
    800: '#9c9ea0'
  },
  background: {
    default: '#ffff',
    paper: '#F2F4F9'
  },
  divider: '#1E2A3A1A'
};

/** Reshet app */
export const dashboardPaletteReshet: PaletteOptions = {
  common: {
    white: '#ffffff'
  },
  warning: {
    main: 'rgb(255, 230, 207)'
  },
  primary: {
    main: '#513996',
    light: '#EDE8F5',
    contrastText: '#ffffff'
  },
  secondary: {
    main: '#1dbcd7'
  },
  grey: { A100: '#E3E3E3', A200: '#f1f1f5' },
  background: {
    default: '#ffff',
    paper: '#f2f2f2'
  }
};
